import { Link } from 'react-router-dom';
import { shows } from '@/mocks/shows';
import ShowCard from '@/components/base/ShowCard';

export default function LatestUpdates() {
  const latest = [...shows].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14" aria-label="最新更新">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="mt-1 text-sm text-foreground-500">每日更新，精彩不断</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5" data-product-shop>
          {latest.map(show => (
            <ShowCard key={show.id} show={show} />
          ))}
        </div>
      </div>
    </section>
  );
}